import { TextField, TextFieldProps } from '@mui/material'
import * as React from 'react'
import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import tz from 'dayjs/plugin/timezone'
import { showErrorToast } from '../../../../services/CommonServices/alertServices'
import { useProjectFeaturesContext } from '../../../project/contexts/ProjectFeaturesContext'

dayjs.extend(utc)
dayjs.extend(tz)

type TimePickerCellProps = {
	timeValue: Date | null
	onChange: (newValue: Date) => Promise<void>
	canEdit: boolean
	maxTime?: Date
	minTime?: Date
}

const TimePickerCell = ({
	timeValue,
	onChange,
	canEdit,
	maxTime,
	minTime,
}: TimePickerCellProps) => {
	const [isOpen, setIsOpen] = useState<boolean>(false)
	const [isDirty, setIsDirty] = useState<boolean>(false)
	const [localValue, setLocalValue] = useState<Date | null>(timeValue)
	const [isAccepted, setIsAccepted] = useState<boolean>(false)
	const { projectTimeZone } = useProjectFeaturesContext()

	useEffect(() => {
		if (isAccepted) {
			;(async () => {
				if (!isValid()) {
					showErrorToast({ message: 'Invalid Time Record' })
					setLocalValue(timeValue)
				} else if (onChange && isDirty && localValue) {
					try {
						await onChange(localValue)
					} catch (error: any) {
						showErrorToast({ message: error.message })
						setLocalValue(timeValue)
					}
				}
				setIsDirty(false)
				setIsOpen(false)
				setIsAccepted(false)
			})()
		}
	}, [isAccepted])

	const isValid = () => {
		// if (minTime) {
		// 	return dayjs(minTime).isBefore(localValue)
		// }
		// if (maxTime) {
		// 	return dayjs(localValue).isBefore(maxTime)
		// }
		return true
	}
	const evaluateColorState = () => {
		return !isValid() ? 'rgba(255,230,222,1)' : 'inherit'
	}
	useEffect(() => {
		if (timeValue) {
			setLocalValue(timeValue)
		}
	}, [timeValue])

	const handleTimeChange = (value: string) => {
		const timeParts = value.split(':')
		const projectTZ = projectTimeZone || 'UTC'
		// Use today's date if localValue is invalid
		const dateStr =
			localValue && !isNaN(localValue.getTime())
				? dayjs(localValue).tz(projectTZ).format('YYYY-MM-DD')
				: dayjs().tz(projectTZ).format('YYYY-MM-DD')
		const dt = dayjs
			.tz(`${dateStr} ${timeParts[0]}:${timeParts[1]}`, projectTZ)
			.set('second', 1)
			.set('millisecond', 0)
		const updatedTime = dt.toDate()

		setLocalValue(updatedTime)
		setIsDirty(true)
	}

	if (isOpen && canEdit) {
		return (
			<>
				<TextField
					label='Enter time'
					type='time'
					sx={{
						backgroundColor: evaluateColorState(),
					}}
					onChange={(e) => handleTimeChange(e.target.value)}
					onBlur={(e) => {
						const timeParts = e.target.value.split(':')
						const projectTZ = projectTimeZone || 'UTC'
						const dateStr = dayjs(localValue).tz(projectTZ).format('YYYY-MM-DD')
						const dt = dayjs
							.tz(`${dateStr} ${timeParts[0]}:${timeParts[1]}`, projectTZ)
							.set('second', 1)
							.set('millisecond', 0)
						const updatedTime = dt.toDate()
						setLocalValue(updatedTime)
						setIsAccepted(true)
					}}
					value={dayjs(localValue)
						.tz(projectTimeZone || 'UTC')
						.format('HH:mm')}
					InputLabelProps={{
						shrink: true,
					}}
					autoFocus
					inputProps={{
						step: 300, // 5 min
						max: maxTime ? dayjs(maxTime).format('HH:mm') : undefined,
						min: minTime ? dayjs(minTime).format('HH:mm') : undefined,
					}}
				/>
			</>
		)
	} else {
		return (
			<div
				onClick={() => {
					if (canEdit) setIsOpen(true)
				}}
			>
				{dayjs(localValue)
					.tz(projectTimeZone || 'UTC')
					.format('h:mm A')}
			</div>
		)
	}
}

export default TimePickerCell
